import CommonModal from "../../../../../Component/Ui-Kits/Modal/Common/CommonModal";
import ConveyanceListDetails from "../listDetails/ConveyanceListDetails";
import { ConveyanceDetails } from "../../../../../utils/Constant";
import { useModalSelector } from "../../../../../hooks/useModalSelector";
import { useAppDispatch } from "../../../../../ReduxToolkit/Hooks";
import { closeModal } from "../../../../../ReduxToolkit/Slice/UserProfileDetailsModalSlice";
import { ConveyanceDetail } from "../../../types";

const ConveyanceListModal = ({ details }: { details: ConveyanceDetail }) => {
  const dispatch = useAppDispatch();
  const { isOpen } = useModalSelector();
  return (
    <CommonModal
      headerClassName="bg-primary"
      titleClassName="text-white"
      title={ConveyanceDetails}
      modalBodyClassName="ps-lg-4"
      centered
      toggle={() => dispatch(closeModal())}
      isOpen={isOpen}
      showFooter={false}
    >
      <div className="modal-toggle-wrapper">
        <ConveyanceListDetails details={details} />
      </div>
    </CommonModal>
  );
};

export default ConveyanceListModal;
